import { render } from "./CarouselComponent.vue?vue&type=template&id=4e293c7e&ts=true"
import script from "./CarouselComponent.vue?vue&type=script&lang=ts"
export * from "./CarouselComponent.vue?vue&type=script&lang=ts"

import "./CarouselComponent.vue?vue&type=style&index=0&id=4e293c7e&lang=scss"

import exportComponent from "/home/runner/work/hph-sitecore-sites/hph-sitecore-sites/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__